import { Reducer } from 'redux';
import baseReducer from '../../utilities/BaseReducer';
import ProductActions from '../actions/productActions';
import IAction from '../../models/IAction';
import { ProductDetailsModel, ProductModel } from '../models/ProductModel';

export interface IProductState {
  createdProduct: string;
  productList: ProductModel[];
  productDeleted: string;
  currentProduct: ProductDetailsModel; 
  updatedProduct: ProductDetailsModel;
  exportProduct: any
}
  
const initialState = {
  createdProduct: '',
  productList: [],
  productDeleted: '',
  currentProduct: new ProductDetailsModel({}),
  updatedProduct: new ProductDetailsModel({}),
  exportProduct: null
};
  
  export const productReducer: Reducer = baseReducer(initialState, {
    [ProductActions.REQUEST_POST_PRODUCT_FINISHED]: (state: IProductState, action: IAction<string>):IProductState => {
      return { 
        ...state,
        createdProduct: action.payload!
      };
    },
    [ProductActions.REQUEST_GET_PRODUCT_LIST_FINISHED]: (state: IProductState, action: IAction<ProductModel[]>):IProductState => {
      return { 
        ...state,
        productList: action.payload!
      };
    },
    [ProductActions.REQUEST_DELETE_PRODUCT_FINISHED]: (state: IProductState, action: IAction<string>):IProductState => {
      return { 
        ...state,
        productDeleted: action.payload!
      };
    },
    [ProductActions.REQUEST_GET_PRODUCT_FINISHED]: (state: IProductState, action: IAction<ProductDetailsModel>):IProductState => {
      return { 
        ...state,
        currentProduct: action.payload!
      };
  },
    [ProductActions.REQUEST_PUT_PRODUCT_FINISHED]: (state: IProductState, action: IAction<ProductDetailsModel>):IProductState => {
      return { 
        ...state,
        updatedProduct: action.payload!
      };
    },
    [ProductActions.REQUEST_EXPORT_PRODUCT_FINISHED]: (state: IProductState, action: IAction<any>):IProductState => {
      return { 
        ...state,
        exportProduct: action.payload!
      };
    }
});